import React from 'react';
import { useSelector } from 'react-redux';
import { translate } from '../../Services/translation';

const ConfiguratorProductDetails = ({ useLongName = false }) => {
  const configurator = useSelector((state) => state.configurator),
    name = useSelector((state) => state.configurator.articleName),
    longName = useSelector((state) => state.configurator.longArticleName),
    description = useSelector((state) => state.configurator.description),
    imgUrl = useSelector((state) => state.configurator.articleImageURL),
    { isCampaignProduct, isEnvironmentalFriendly, isLoggedIn } = configurator;

  return (
    <div className='configurator-details__selected-product'>
      <div className='product__image'>
        <figure>
          <img src={imgUrl} alt='product' />
          {isCampaignProduct && isLoggedIn && (
            <div className='product__campaign-banner product__campaign-banner__side'>
              {translate('product.campaignbanner')}
            </div>
          )}
          {isEnvironmentalFriendly && isLoggedIn && (
            <div className='env-tag-outer'>
              <span className='env-tooltip--data'>
                <span className='data-tooltip' data-tip={translate('product.environmentalfriendly.hover')} data-html='true'
                >
                  <svg className='enviroment-image'>
                    <use
                      href={`/ui/images/sprites/be-group.svg#environmental-friendly`}
                    ></use>
                  </svg>
                </span>
              </span>
            </div>
          )}
        </figure>
      </div>
      <div>
        <h1 className='configurator-details__header'>
          {useLongName ? longName : name}
        </h1>
        <p>{description}</p>
      </div>
    </div>
  );
};

export default ConfiguratorProductDetails;
